import script from "./receive-payment-status.vue?vue&type=script&setup=true&lang=js"
export * from "./receive-payment-status.vue?vue&type=script&setup=true&lang=js"

import "./receive-payment-status.vue?vue&type=style&index=0&id=3cf0deb4&lang=css"

const __exports__ = script;

export default __exports__